import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../../helpers/Modal';
import Button from '../../../components/forms/Button';
import { TextField } from '@material-ui/core';

class ReviewCodeModal extends Component {
    state = { pin: '' };

    _inputPin = e => {
        this.setState({ pin: e.target.value });
    };

    _confirmModal = () => {
        return this.props.confirmAction(this.state.pin);
    };

    render() {
        const { error } = this.props;
        return (
            <Modal className={'is-big'} open={this.props.open} noClose>
                <div className="ckp-review-modal">
                    <h1 className="ckp-admin-modal-forms-title ckp-ts-h1 u-text-center">Hello</h1>
                    <p className="u-text-center">Enter the PIN code you've received via email.</p>
                    <div className="ckp-modal-content-centered u-margin-top-2">
                        <TextField
                            className="ckp-inputs"
                            id="pinCode"
                            label="PIN Code"
                            onInput={this._inputPin}
                            value={this.state.pin}
                            helperText={error}
                            error={!!error}
                            margin="normal"
                            autoComplete="one-time-code"
                        />
                        <Button
                            className="ckp-review-modal-button"
                            type="button"
                            onClick={this._confirmModal}
                            label={'Submit'}
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state, props) => ({});

export default connect(mapStateToProps)(ReviewCodeModal);
